import React from 'react';
import { makeStyles } from "@material-ui/core/styles"
import { getTranslation } from "../scripts/getTranslation"
import { useStore } from "../teafuljs/store"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import SphereViewData from '../data/SphereViewData.json'

const useStyles = makeStyles(theme => ({
  block: {
    borderTop: `2px solid ${theme.palette.primary.main}`,
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    paddingTop: '20px'
  },
  slogan: {
    fontStyle: "italic",
    textAlign: "center",
    fontSize: "150%",
    margin: "10px 0 20px 0",
    whiteSpace: 'pre-line',
    padding: "0 20px"
  },
  iconsBlock: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  sphereViewIconContainer: {
    padding: 10,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    width: 60,
    height: 60,
    fontSize: 16,
    textAlign: "center"
  },
  instructionText: {
    textAlign: "center",
    fontStyle: "italic",
    fontSize: "0.9rem",
    color: "grey",
    margin: "-10px 0 0 0",
  }
}))

export default function SphereViewBlock({ selected, setSelected, setClicked }) {
  const translations = useStore.translations()[0]
  const language = useStore.language()[0]
  const classes = useStyles()
  return (
    <div className={classes.block}>
      <p className={classes.instructionText}>Tap on the icons to see the key passages below</p>
      <div className={classes.iconsBlock}>
        <div
          className={classes.sphereViewIconContainer}
          onClick={() => {
            setSelected("INT")
            setClicked(true)
          }}
          style={
            selected === "INT"
              ? {
                  border: "2px solid black",
                  borderRadius: 30,
                  padding: 5,
                }
              : {}
          }
        >
          <img src={require(`../../static/images/SphereViewCarouselcircle.png`)} />
        </div>
        {SphereViewData.map(sphereData => {
          return (
            <div
              className={classes.sphereViewIconContainer}
              onClick={() => {
                setSelected(sphereData.id)
                setClicked(true)
              }}
              style={
                selected === sphereData.id
                  ? {
                      border: "2px solid black",
                      borderRadius: 30,
                      padding: 5,
                    }
                  : {}
              }
            >
              <img
                src={require(`../../static/images/${sphereData.name}.png`)}
              />
            </div>
          )
        })}
      </div>
      <Typography variant="h1" className={classes.slogan}>
        {getTranslation(translations, language, "KeyPassages", selected)}
        {"\n"}
        {getTranslation(
          translations,
          language,
          "UI",
          "menu_sphere_key_passages"
        )}
      </Typography>
    </div>
  )
}